import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-neutral-100 flex flex-col" }
const _hoisted_2 = { class: "container max-w-5xl mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<h1 class=\"text-3xl mt-8 mb-6 ml-6\">How to view DNS records in Google Chrome?</h1><div class=\"flex flex-col bg-white shadow p-6 pb-10 rounded sm:flex-row\"><div class=\"w-1/2 prose prose-indigo\"><p class=\"mt-2\">Google Chrome itself does not provide a way to view DNS records of the websites you visit. However, you can install <a href=\"https://chrome.google.com/webstore/detail/nslookup-find-dns-records/kedbaefjfjpplphppofakpfldhimhcio\" title=\"NsLookup for Chrome\" target=\"_blank\" rel=\"noopener noreferrer\">the nslookup extension</a> to do so.</p><p>This add-on allows you to view A records, AAAA records, see the name servers and mail servers and all the other DNS records for any domain name or subdomain.</p><p>Follow this step by step guide to be able to easily view DNS records in Google Chrome.</p><ol><li><a href=\"/install/how-to-view-dns-records-in-chrome/#step1\">Visit the NsLookup extension page in the Chrome Web Store</a></li><li><a href=\"/install/how-to-view-dns-records-in-chrome/#step2\">Click Add to Chrome</a></li><li><a href=\"/install/how-to-view-dns-records-in-chrome/#step3\">Click &quot;Add extension&quot;</a></li><li><a href=\"/install/how-to-view-dns-records-in-chrome/#step4\">Visit the website you want to view the DNS records for</a></li><li><a href=\"/install/how-to-view-dns-records-in-chrome/#step5\">Open the extension menu</a></li><li><a href=\"/install/how-to-view-dns-records-in-chrome/#step6\">Click on the NsLookup extension</a></li><li><a href=\"/install/how-to-view-dns-records-in-chrome/#step7\">View the DNS records</a></li></ol></div><img class=\"w-full m-0 sm:w-1/2 mb-auto\" src=\"img/tutorials/install/chrome/how-to-view-dns-records-in-chrome.png\" alt=\"How to view DNS records in Google Chrome\" width=\"504\" height=\"252\"></div>", 2)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("In Google Chrome, "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://chrome.google.com/webstore/detail/nslookup-find-dns-records/kedbaefjfjpplphppofakpfldhimhcio",
    title: "NsLookup for Chrome",
    target: "_blank",
    rel: "noopener noreferrer"
  }, "click here"),
  /*#__PURE__*/_createTextVNode(" to visit the Chrome extension page for the NsLookup extension.")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Click the "),
  /*#__PURE__*/_createElementVNode("strong", null, "Add to Chrome"),
  /*#__PURE__*/_createTextVNode(" button to download and install the extension.")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("Chrome will prompt you to confirm that you want to add this extension to your browser. "),
  /*#__PURE__*/_createElementVNode("strong", null, "Click \"Add extension\""),
  /*#__PURE__*/_createTextVNode(" to add the extension.")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "Open a new tab and visit the website that you want to view the DNS records for.", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("In the top-right corner of your browser, "),
  /*#__PURE__*/_createElementVNode("strong", null, "click the puzzle piece"),
  /*#__PURE__*/_createTextVNode(". This opens the menu containing all the installed extensions.")
], -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, [
  /*#__PURE__*/_createTextVNode("In this menu, "),
  /*#__PURE__*/_createElementVNode("strong", null, "click \"NsLookup - Find DNS Records\""),
  /*#__PURE__*/_createTextVNode(". This will show you the DNS records for the domain name of your active tab.")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("p", null, "You can now see the DNS records for the domain you just visited. If the record type you're looking for is not shown, scroll to the bottom to select it from the drop-down.", -1)

import HeaderComponent from '@/components/layout/HeaderComponent.vue';
import FooterComponent from '@/components/layout/FooterComponent.vue';
import MetaTags from '@/components/MetaTags.vue';
import GuideStep from '@/components/layout/GuideStep.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'InstallChrome',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "head" }, [
      _createVNode(MetaTags, {
        title: "How to view DNS records in Chrome?",
        description: "View DNS records in Chrome. Inspect all DNS record types and popular DNS caches as well as multiple geographical locations.",
        url: "https://www.nslookup.io/install/how-to-view-dns-records-in-chrome/",
        img1024x512: "https://www.nslookup.io/img/tutorials/install/chrome/how-to-view-dns-records-in-chrome.png",
        img1200x630: "https://www.nslookup.io/img/tutorials/install/chrome/how-to-view-dns-records-in-chrome.png"
      })
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(HeaderComponent),
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createVNode(GuideStep, {
          step: 1,
          title: "Visit the NsLookup extension page in the Chrome Web Store",
          img: "img/tutorials/install/chrome/nslookup-extension-chrome.png",
          "img-width": 504,
          "img-height": 272
        }, {
          default: _withCtx(() => [
            _hoisted_5
          ]),
          _: 1
        }),
        _createVNode(GuideStep, {
          step: 2,
          title: "Click Add to Chrome",
          img: "img/tutorials/install/chrome/add-to-chrome.png",
          "img-width": 504,
          "img-height": 272
        }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(GuideStep, {
          step: 3,
          title: "Click \"Add extension\"",
          img: "img/tutorials/install/chrome/add-extension.png",
          "img-width": 504,
          "img-height": 270
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(GuideStep, {
          step: 4,
          title: "Visit the website you want to view the DNS records for",
          img: "img/tutorials/install/chrome/example-domain-name.png",
          "img-width": 504,
          "img-height": 251
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        }),
        _createVNode(GuideStep, {
          step: 5,
          title: "Open the extension menu",
          img: "img/tutorials/install/chrome/chrome-extensions-menu.png",
          "img-width": 504,
          "img-height": 222
        }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(GuideStep, {
          step: 6,
          title: "Click on the NsLookup extension",
          img: "img/tutorials/install/chrome/view-dns-records-for-domain.png",
          "img-width": 504,
          "img-height": 223
        }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _createVNode(GuideStep, {
          step: 7,
          title: "View the DNS records",
          img: "img/tutorials/install/chrome/dns-record-viewer.png",
          "img-width": 504,
          "img-height": 299
        }, {
          default: _withCtx(() => [
            _hoisted_11
          ]),
          _: 1
        })
      ]),
      _createVNode(FooterComponent, { class: "mt-6" })
    ])
  ], 64))
}
}

})